import React, { useState, useEffect } from "react";
import AdminService from "../services/AdminService";
import { toast } from "react-toastify";
import AdminChatWindow from "../components/AdminChatWindow";

const SupportManagement = () => {
    const [activeTab, setActiveTab] = useState("messages");
    const [announcement, setAnnouncement] = useState({ title: "", message: "", target: "all" });
    const [sending, setSending] = useState(false);
    const [plans, setPlans] = useState([]);

    useEffect(() => {
        fetchPlans();
    }, []);

    const fetchPlans = async () => {
        try {
            const response = await AdminService.getPlans();
            const data = response.data?.data || response.data || [];
            if (Array.isArray(data)) {
                setPlans(data);
            }
        } catch (error) {
            console.error("Error loading plans:", error);
        }
    };

    const handleSendAnnouncement = async () => {
        if (!announcement.title.trim() || !announcement.message.trim()) {
            toast.error("Title and message are required");
            return;
        }
        setSending(true);
        try {
            const response = await AdminService.sendAnnouncement(announcement);
            if (response.data && response.data.status) {
                toast.success(response.data.message || "Announcement sent successfully");
                setAnnouncement({ title: "", message: "", target: "all" });
            } else {
                toast.error(response.data?.message || "Failed to send announcement");
            }
        } catch (error) {
            console.error("Error sending announcement:", error);
            toast.error("An error occurred while sending announcement");
        } finally {
            setSending(false);
        }
    };

    const getTargetLabel = () => {
        if (announcement.target === "all") return "All Users";
        if (announcement.target === "zero_coins") return "Users with 0 Coins";
        const plan = plans.find(p => {
            const sub = p.subscription || p;
            return String(sub.id) === announcement.target;
        });
        if (plan) {
            const sub = plan.subscription || plan;
            return `${sub.type} Plan Users`;
        }
        return "Selected Users";
    };

    return (
        <div>
            <div className="admin-tabs">
                <button className={`admin-tab ${activeTab === "messages" ? "active" : ""}`} onClick={() => setActiveTab("messages")}>
                    Messages
                </button>
                <button className={`admin-tab ${activeTab === "announcements" ? "active" : ""}`} onClick={() => setActiveTab("announcements")}>
                    Announcements
                </button>
            </div>

            {activeTab === "messages" && (
                <AdminChatWindow />
            )}

            {activeTab === "announcements" && (
                <div className="admin-card">
                    <div className="admin-card-header">
                        <h3>Send Announcement</h3>
                    </div>
                    <div className="admin-card-body admin-announcement-form">
                        <div className="admin-form-group">
                            <label>Title *</label>
                            <input
                                type="text"
                                className="admin-form-control"
                                placeholder="Announcement title"
                                value={announcement.title}
                                onChange={(e) => setAnnouncement({ ...announcement, title: e.target.value })}
                            />
                        </div>
                        <div className="admin-form-group">
                            <label>Message *</label>
                            <textarea
                                className="admin-form-control"
                                placeholder="Type your announcement message..."
                                value={announcement.message}
                                onChange={(e) => setAnnouncement({ ...announcement, message: e.target.value })}
                                rows={5}
                            ></textarea>
                        </div>
                        <div className="admin-form-group">
                            <label>Target Audience</label>
                            <select
                                className="admin-form-control"
                                value={announcement.target}
                                onChange={(e) => setAnnouncement({ ...announcement, target: e.target.value })}
                            >
                                <option value="all">All Users</option>
                                <option value="zero_coins">Users with 0 Coins</option>
                                {plans.map((p) => {
                                    const sub = p.subscription || p;
                                    return (
                                        <option key={sub.id} value={sub.id}>
                                            {sub.type} Plan Users
                                        </option>
                                    );
                                })}
                            </select>
                            <div className="admin-form-helper" style={{ marginTop: "6px" }}>
                                <i className="fa fa-info-circle" style={{ marginRight: "5px" }}></i>
                                Sending to: <strong>{getTargetLabel()}</strong>
                            </div>
                        </div>
                        <div className="admin-form-actions">
                            <button
                                className="admin-btn admin-btn-primary"
                                onClick={handleSendAnnouncement}
                                disabled={sending}
                            >
                                {sending ? (
                                    <><i className="fa fa-spinner fa-spin"></i> Sending...</>
                                ) : (
                                    <><i className="fa fa-bullhorn"></i> Send Announcement</>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SupportManagement;
